import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { ORDERED_DIMENSIONS } from '../../../../../../common/model/types';
import { AwesomeActionIcon } from '../../../../generic/components/icons/awesome-action-icon';
import InfoTooltipWithIcon from '../../../../generic/components/tooltips/info-tooltip-with-icon';
import { getTextStyle } from '../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../generic/global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../../../../generic/layout/bou-spacing';
import { DimensionBlock } from './blocks/dimension-block';
import { useValuesSelectorContextBuilder, ValuesSelectorContextProvider } from './context';
import { Dropdown } from './dropdown';

interface Props {
  close: () => void;
}

export function ValuesSelectorMain(props: Props) {
  const context = useValuesSelectorContextBuilder();

  return (
    <ValuesSelectorContextProvider value={context}>
      <Root>
        <TopPart>
          <TitleRow>
            <YourValuesTitle>
              Your values
              <InfoTooltipWithIcon
                content={
                  <div style={{ maxWidth: '30rem' }}>
                    What do you want to optimize? Choose a pre-formulated value set or give each impact your desired
                    weight.
                  </div>
                }
                style={{ fontSize: 18, paddingLeft: 12 }}
              />
            </YourValuesTitle>
            <div onClick={() => props.close()} style={{ fontSize: 18 }}>
              <AwesomeActionIcon icon={faTimes} />
            </div>
          </TitleRow>
          <div>
            <Dropdown />
          </div>
        </TopPart>
        <Dimensions>
          <ValuesLegend>0 = ignore, 5 = highly prioritized</ValuesLegend>
          {ORDERED_DIMENSIONS.map(d => {
            return <DimensionBlock key={d} dimension={d} />;
          })}
        </Dimensions>
      </Root>
    </ValuesSelectorContextProvider>
  );
}

const Root = styled.div`
  ${fluidSpacing('padding-left', BouSpacingLevel.TINY)}
  ${fluidSpacing('padding-right', BouSpacingLevel.TINY)}
  ${getTextStyle({ size: 'xxxs' })}
`;

const TopPart = styled.div`
  ${fluidSpacing('padding-top', BouSpacingLevel.TINYISH)}
  ${fluidSpacing('padding-bottom', BouSpacingLevel.TINY)}
`;

const Dimensions = styled.div`
  border-top: 2px solid #eeeeee;
`;

const ValuesLegend = styled.div`
  font-style: italic;
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
  ${fluidSpacing('padding-top', BouSpacingLevel.TINY)}
`;

const YourValuesTitle = styled.div`
  color: ${BouColor.TOOL_TEXT_BLACK};
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 18px;
`;
